import { render, staticRenderFns } from "./CloudDownloadIcon.vue?vue&type=template&id=6ff9dfde"
import script from "./CloudDownloadIcon.vue?vue&type=script&lang=js"
export * from "./CloudDownloadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports